'use client';

import { useState } from 'react';
import type { Address } from 'src/model/Address';

interface NewAddressData {
  zipcode: string;
  street: string;
  number: string;
  district: string;
  city: string;
  state: string;
  complement: string;
  main: string;
}

interface NewAddressErrors {
  zipcode?: string[];
  street?: string[];
  number?: string[];
  district?: string[];
  city?: string[];
  state?: string[];
}

export const useAddressForm = (addresses: Address[] = []) => {
  const [selectedAddressId, setSelectedAddressId] = useState<string>('');
  const [showNewAddressForm, setShowNewAddressForm] = useState<boolean>(false);
  const [newAddressData, setNewAddressData] = useState<NewAddressData>({
    zipcode: '',
    street: '',
    number: '',
    district: '',
    city: '',
    state: '',
    complement: '',
    main: 'false',
  });
  const [newAddressErrors, setNewAddressErrors] = useState<NewAddressErrors>(
    {}
  );

  const handleAddressSelection = (addressId: string) => {
    setSelectedAddressId(addressId);
    setShowNewAddressForm(addressId === 'new');
  };

  const handleNewAddressInput =
    (field: keyof NewAddressData) => (value: string) => {
      setNewAddressData((prev) => ({
        ...prev,
        [field]: value,
      }));

      // Limpar erro do campo quando o usuário começar a digitar
      if (newAddressErrors[field as keyof NewAddressErrors]) {
        setNewAddressErrors((prev) => ({
          ...prev,
          [field]: undefined,
        }));
      }
    };

  const handleCEPChange = async (cep: string) => {
    // Remover caracteres não numéricos
    const cleanCEP = cep.replace(/\D/g, '');

    if (cleanCEP.length === 8) {
      try {
        const response = await fetch(
          `https://viacep.com.br/ws/${cleanCEP}/json/`
        );
        const data = await response.json();

        if (!data.erro) {
          setNewAddressData((prev) => ({
            ...prev,
            street: data.logradouro || '',
            district: data.bairro || '',
            city: data.localidade || '',
            state: data.uf || '',
          }));
        }
      } catch (error) {
        console.error('Erro ao buscar CEP:', error);
      }
    }
  };

  return {
    selectedAddressId,
    showNewAddressForm,
    newAddressData,
    newAddressErrors,
    handleAddressSelection,
    handleNewAddressInput,
    handleCEPChange,
    setNewAddressErrors,
  };
};
